import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { ReportAttendanceListComponent } from './report-attendance-list/report-attendance-list.component'
import { ReportConversationAnalyticsComponent } from './report-conversation-analytics/report-conversation-analytics.component'
import { ReportCsatListComponent } from './report-csat-list/report-csat-list.component'
import { ReportListContactComponent } from './report-list-contact/report-list-contact.component'
import { ReportListImportationComponent } from './report-list-importation/report-list-importation.component'
import { ReportListComponent } from './report-list/report-list.component'
import { ReportSalesMonitorComponent } from './report-sales-monitor/report-sales-monitor.component'
import { ReportTabulationAttendanceComponent } from './report-tabulation-attendance/report-tabulation-attendance.component'
import { ReportComponent } from './report.component'
import { TrackingReportComponent } from './tracking-report/tracking-report.component'
import { ReportTemplatesAnalyticsComponent } from './report-templates-analytics/report-templates-analytics.component'
import { TemplateAnalyticsDetailComponent } from './report-templates-analytics/template-analytics-detail/template-analytics-detail.component'
import { ReportLeadSourceComponent } from './report-lead-source/report-lead-source.component'
import { ReportApiLoggingsComponent } from './report-api-loggings/report-api-loggings.component'

const routes: Routes = [
  { path: '', component: ReportComponent },
  { path: ':id/detail', component: TemplateAnalyticsDetailComponent },
  { path: 'view-performance', component: ReportListComponent },
  { path: 'view-contact', component: ReportListContactComponent },
  { path: 'view-importation', component: ReportListImportationComponent },
  { path: 'view-csat', component: ReportCsatListComponent },
  { path: 'view-attendance', component: ReportAttendanceListComponent },
  { path: 'view-tabulation-attendance', component: ReportTabulationAttendanceComponent },
  { path: 'view-sales-monitor', component: ReportSalesMonitorComponent },
  { path: 'view-tracking', component: TrackingReportComponent },
  { path: 'view-insights-messages', component: ReportConversationAnalyticsComponent },
  { path: 'view-insights-templates', component: ReportTemplatesAnalyticsComponent },
  { path: 'view-lead-source', component: ReportLeadSourceComponent },
  { path: 'view-api-logging', component: ReportApiLoggingsComponent }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportRoutingModule { }
